import {getProjectId} from 'common/report/util/index';

import {BaseClient} from '../utils/base-client';

class ProjectDetailsClient extends BaseClient {
  buildEndpoint({projectId}) {
    return projectId ? `api/app/projects/${projectId}/metadata` : `api/app/projects/metadata`;
  }

  processResponse(response) {
    return response.results;
  }
}

export const projectDetailsClient = new ProjectDetailsClient();

class CurrentProjectClient extends BaseClient {
  buildEndpoint({projectId}) {
    projectId = projectId || getProjectId();
    if (!projectId) {
      throw new Error(`Attempting to query current project when no ID is available`);
    }
    return `api/app/projects/${projectId}/metadata`;
  }

  processResponse(response) {
    return response.results;
  }
}

export const currentProjectClient = new CurrentProjectClient();
